import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Directive, EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';

function XpoTabsDrawer_button_5_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_left");
    i0.ɵɵelementEnd();
} }
function XpoTabsDrawer_button_5_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "arrow_right");
    i0.ɵɵelementEnd();
} }
function XpoTabsDrawer_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 4);
    i0.ɵɵlistener("click", function XpoTabsDrawer_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.toggle(); });
    i0.ɵɵtemplate(1, XpoTabsDrawer_button_5_mat_icon_1_Template, 2, 0, "mat-icon", 5);
    i0.ɵɵtemplate(2, XpoTabsDrawer_button_5_mat_icon_2_Template, 2, 0, "mat-icon", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.opened);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.opened);
} }
const _c0 = [[["", "xpo-shell-navigation", ""]], "*", [["xpo-tab-drawer-content"]]];
const _c1 = ["[xpo-shell-navigation]", "*", "xpo-tab-drawer-content"];
class XpoTabDrawerContent {
}
XpoTabDrawerContent.ɵfac = function XpoTabDrawerContent_Factory(t) { return new (t || XpoTabDrawerContent)(); };
XpoTabDrawerContent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoTabDrawerContent, selectors: [["xpo-tab-drawer-content"]], hostAttrs: [1, "xpo-TabDrawer-content"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTabDrawerContent, [{
        type: Directive,
        args: [{
                selector: 'xpo-tab-drawer-content',
                host: { class: 'xpo-TabDrawer-content' },
            }]
    }], null, null); })();
class XpoTabsDrawer {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.openedValue = true;
        this.showCollapseButtonValue = true;
        this.modeValue = 'side';
        this.openedChange = new EventEmitter();
    }
    /**
     * Whether or not the drawer should be open
     */
    get opened() {
        return this.openedValue;
    }
    set opened(value) {
        this.openedValue = coerceBooleanProperty(value);
        this.openedChange.emit(this.openedValue);
        // closing drawer doesn't trigger resize
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);
    }
    /**
     * Hide/show collapse button
     */
    get showCollapseButton() {
        return this.showCollapseButtonValue;
    }
    set showCollapseButton(value) {
        this.showCollapseButtonValue = coerceBooleanProperty(value);
    }
    get mode() {
        return this.modeValue;
    }
    set mode(value) {
        this.modeValue = value;
        this.changeDetectorRef.markForCheck();
    }
    /**
     * Toggle hiding/showing drawer
     */
    toggle() {
        this.opened = !this.opened;
        this.changeDetectorRef.markForCheck();
    }
}
XpoTabsDrawer.ɵfac = function XpoTabsDrawer_Factory(t) { return new (t || XpoTabsDrawer)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoTabsDrawer.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoTabsDrawer, selectors: [["xpo-tab-drawer"]], hostAttrs: [1, "xpo-TabDrawer"], inputs: { opened: "opened", showCollapseButton: "showCollapseButton", mode: "mode" }, outputs: { openedChange: "openedChange" }, ngContentSelectors: _c1, decls: 7, vars: 3, consts: [[1, "xpo-TabDrawer-container"], [1, "xpo-TabDrawer-nav", 3, "mode", "opened", "openedChange"], [1, "xpo-TabDrawer-contentWrapper"], ["class", "xpo-TabDrawer-button", 3, "click", 4, "ngIf"], [1, "xpo-TabDrawer-button", 3, "click"], [4, "ngIf"]], template: function XpoTabsDrawer_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "mat-drawer-container", 0);
        i0.ɵɵelementStart(1, "mat-drawer", 1);
        i0.ɵɵlistener("openedChange", function XpoTabsDrawer_Template_mat_drawer_openedChange_1_listener($event) { return ctx.opened = $event; });
        i0.ɵɵprojection(2);
        i0.ɵɵprojection(3, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "mat-drawer-content", 2);
        i0.ɵɵtemplate(5, XpoTabsDrawer_button_5_Template, 3, 2, "button", 3);
        i0.ɵɵprojection(6, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("mode", ctx.mode)("opened", ctx.opened);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.showCollapseButton);
    } }, directives: [i1.MatDrawerContainer, i1.MatDrawer, i1.MatDrawerContent, i2.NgIf, i3.MatIcon], styles: [".flex--stretch{flex:1}.xpo-TabDrawer{display:flex;flex-direction:column;height:100%;overflow:auto;width:100%}.xpo-TabDrawer-container{display:flex;flex-direction:column;height:100%;overflow:auto;width:100%}.xpo-TabDrawer-nav{background-color:#fff;border-right:1px solid #d8d8d8;min-width:251px;overflow:visible!important}.xpo-TabDrawer-content{display:flex;flex-direction:column;height:100%}.xpo-TabDrawer-contentWrapper.mat-drawer-content{padding:0 16px;z-index:unset}.xpo-TabDrawer-button{background-color:#fff;border:1px solid #d8d8d8;border-left:none;bottom:50%;cursor:pointer;height:60px;outline:none;position:fixed;transform:translate(-17px);width:14px;z-index:3}.xpo-TabDrawer-button-icon{color:#0868ac;transform:translate(-3px)}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTabsDrawer, [{
        type: Component,
        args: [{
                selector: 'xpo-tab-drawer',
                templateUrl: './tab-drawer.html',
                styleUrls: ['./tab-drawer.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-TabDrawer' },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { opened: [{
            type: Input
        }], openedChange: [{
            type: Output
        }], showCollapseButton: [{
            type: Input
        }], mode: [{
            type: Input
        }] }); })();

class XpoTabDrawerModule {
}
XpoTabDrawerModule.ɵfac = function XpoTabDrawerModule_Factory(t) { return new (t || XpoTabDrawerModule)(); };
XpoTabDrawerModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoTabDrawerModule });
XpoTabDrawerModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, MatSidenavModule, MatIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoTabDrawerModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoTabDrawerContent, XpoTabsDrawer],
                imports: [CommonModule, MatSidenavModule, MatIconModule],
                exports: [XpoTabDrawerContent, XpoTabsDrawer],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoTabDrawerModule, { declarations: [XpoTabDrawerContent, XpoTabsDrawer], imports: [CommonModule, MatSidenavModule, MatIconModule], exports: [XpoTabDrawerContent, XpoTabsDrawer] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoTabDrawerContent, XpoTabDrawerModule, XpoTabsDrawer };
